import React, { useState } from 'react';

import { uuid } from 'short-uuid';
import styled from 'styled-components';

import { isIncentivesCorporate, isIncentivesSalesperson } from 'helpers/permissions';
import { useAppSelector } from 'store/hook';

import { INCENTIVES_TABS } from './constants';
import IncentivesHeader from './header/IncentivesHeader';
import { IncentivesContext } from './IncentivesContext';
import IncentivesData from './IncentivesData';
import IncentivesTabs from './IncentivesTabs';
import IncentivesProposalModal from './proposal/IncentivesProposalModal';
import { ProposalType, UnitType } from './types';

const Container = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
`;

const IncentivesOverview = () => {
  const { currentUser } = useAppSelector((state) => state.auth);

  const [currentTab, setCurrentTab] = useState(INCENTIVES_TABS.UNIT);
  const [search, setSearch] = useState('');
  const [selectedProposalUnit, setSelectedProposalUnit] = useState<UnitType | undefined>(undefined);
  const [selectedProposal, setSelectedProposal] = useState<ProposalType | undefined>(undefined);
  const [key, setKey] = useState<string>(uuid());

  return (
    <IncentivesContext.Provider
      value={{
        currentTab,
        search,
        key,
        selectedProposalUnit,
        selectedProposal,
        setSelectedProposal,
        setCurrentTab,
        setSelectedProposalUnit,
        setKey,
        setSearch,
      }}
    >
      <Container>
        <IncentivesProposalModal />
        <IncentivesHeader />
        {(isIncentivesCorporate(currentUser) || isIncentivesSalesperson(currentUser)) && <IncentivesTabs />}
        <IncentivesData
          archiveMode={currentTab === INCENTIVES_TABS.ARCHIVE}
          onSelectionChanged={() => {
            // Do nothing
          }}
        />
      </Container>
    </IncentivesContext.Provider>
  );
};

export default IncentivesOverview;
